import { axiosBase } from 'utils';

const request = (method, url, data, params) => {
  const axios = axiosBase.create();
  return axios({ method, url, data, params });
};

export const schedulingActivitiesListService = () =>
  request('GET', '/scheduling/activities');
export const schedulingActivityGetService = (id) =>
  request('GET', `/scheduling/activities/${id}`);
export const schedulingActivityCreateService = (values) =>
  request('POST', '/scheduling/activities', values);
export const schedulingActivityUpdateService = (id, values) =>
  request('PATCH', `/scheduling/activities/${id}`, values);
export const schedulingActivityDeleteService = (id) =>
  request('DELETE', `/scheduling/activities/${id}`);

export const schedulingSchedulesListService = () =>
  request('GET', '/scheduling/schedules');
export const schedulingScheduleGetService = (id) =>
  request('GET', `/scheduling/schedules/${id}`);
export const schedulingScheduleCreateService = (values) =>
  request('POST', '/scheduling/schedules', values);
export const schedulingScheduleUpdateService = (id, values) =>
  request('PATCH', `/scheduling/schedules/${id}`, values);
export const schedulingScheduleDeleteService = (id) =>
  request('DELETE', `/scheduling/schedules/${id}`);
export const schedulingSchedulePublishService = (id, values) =>
  request('POST', `/scheduling/schedules/${id}/publish`, values);

export const schedulingShiftsListService = (params) =>
  request('GET', '/scheduling/shifts', undefined, params);
export const schedulingMyShiftsForClockService = (params) =>
  request('GET', '/scheduling/shifts/my-for-clock', undefined, params);
export const schedulingShiftGetService = (id) =>
  request('GET', `/scheduling/shifts/${id}`);
export const schedulingShiftCreateService = (values) =>
  request('POST', '/scheduling/shifts', values);
export const schedulingShiftClearWeekService = (values) =>
  request('POST', '/scheduling/shifts/clear-week', values);
export const schedulingShiftUpdateService = (id, values) =>
  request('PATCH', `/scheduling/shifts/${id}`, values);
export const schedulingShiftDeleteService = (id) =>
  request('DELETE', `/scheduling/shifts/${id}`);
export const schedulingShiftDuplicateService = (id, values = {}) =>
  request('POST', `/scheduling/shifts/${id}/duplicate`, values);
export const schedulingShiftClaimService = (id) =>
  request('POST', `/scheduling/shifts/${id}/claim`);
export const schedulingShiftSwapRequestService = (id, values = {}) =>
  request('POST', `/scheduling/shifts/${id}/swap-request`, values);
export const schedulingSwapsListService = (params) =>
  request('GET', '/scheduling/swaps', undefined, params);
export const schedulingSwapClaimService = (id) =>
  request('POST', `/scheduling/swaps/${id}/claim`);
export const schedulingSwapCancelService = (id) =>
  request('POST', `/scheduling/swaps/${id}/cancel`);

export const schedulingAvailabilityListService = (params) =>
  request('GET', '/scheduling/availability', undefined, params);
export const schedulingAvailabilityCreateService = (values) =>
  request('POST', '/scheduling/availability', values);
export const schedulingAvailabilityDeleteService = (id) =>
  request('DELETE', `/scheduling/availability/${id}`);
export const schedulingAvailabilityMatchService = (params) =>
  request('GET', '/scheduling/availability/match', undefined, params);
